import { httpClient } from '../core/http';

export interface ContactPayload {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export class ContactService {
  private basePath = '/v1/contact';

  /**
   * Envia os dados de contato para o backend.
   * @param payload Dados do contato
   */
  async submitContact(payload: ContactPayload): Promise<void> {
    await httpClient.post(this.basePath, payload);
  }
}

export const contactService = new ContactService();
